/* This file is autogenerated, see readme.md for instructions */
import StartFillSvgIcon from '@bloomreach/banana-theme/icons/start-fill.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const StartFillIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <StartFillSvgIcon />
    </Icon>
  );
});

StartFillIcon.displayName = 'StartFillIcon';

export default StartFillIcon;
